// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider, useAuth } from "./AuthContext";

// Pages
import LandingPage from "./LandingPage";
import WalletTracer from "./WalletTracer";

// Stripe return pages
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";

// Legal pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AboutTransparency from "./pages/AboutTransparency";
import TermsOfUse from "./pages/TermsOfUse";

/* ======================================================
   PROTECTED ROUTE
   - Requires logged-in user
   - Requires verified email
====================================================== */
function ProtectedRoute({ children }) {
  const { user, authLoading } = useAuth();

  if (authLoading) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        Checking session…
      </div>
    );
  }

  if (!user || !user.emailVerified) {
    return <Navigate to="/" replace />;
  }

  return children;
}

/* ======================================================
   APP ROUTER
====================================================== */
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>

          {/* Landing */}
          <Route path="/" element={<LandingPage />} />

          {/* Main App (protected) */}
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <WalletTracer />
              </ProtectedRoute>
            }
          />

          {/* Stripe Redirects */}
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />

          {/* Legal */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<AboutTransparency />} />
          <Route path="/terms" element={<TermsOfUse />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
